var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-progress-linear',{attrs:{"indeterminate":""}}),_c('v-alert',[_vm._v(_vm._s(_vm.$t('bookings.infos.fetching_vehicle_info')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }